import { render, staticRenderFns } from "./HeaderAtendimento.vue?vue&type=template&id=b2c0941e"
import script from "./HeaderAtendimento.vue?vue&type=script&lang=js"
export * from "./HeaderAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports